export default __webpack_public_path__ + "static/media/GE-OS.31cef280.svg";